// Copyright 2006 The Closure Library Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

/**
 * @fileoverview Basic class for matching words in an array.
 */


goog.provide('el8.service.Search');


/**
 * Basic class for matching words in an array
 * @constructor
 * @param {Array} rows Dictionary of items to match.  Can be objects if they
 *     have a toString method that returns the value to match against.
 * @param {boolean=} opt_noSimilar if true, do not do similarity matches for the
 *     input token against the dictionary.
 */
el8.service.Search = function(rows, opt_noSimilar, rowToStringFn) {
  this.setRows(rows);
  this.useSimilar_ = !opt_noSimilar;
  this.rowToStringFn_ = rowToStringFn || function(row) { return String(row); };
};


/**
 * Function used to pass matches to the autocomplete
 * @param {string} token Token to match.
 * @param {number} maxMatches Max number of matches to return.
 * @param {Function} matchHandler callback to execute after matching.
 * @param {string=} opt_fullString The full string from the input box.
 */
el8.service.Search.prototype.requestMatchingRows =
    function(token, maxMatches, matchHandler, opt_fullString) {

  var matches = this.getPrefixMatches(token, maxMatches);

  if (matches.length === 0 && this.useSimilar_) {
    matches = this.getSimilarRows(token, maxMatches);
  }
  matchHandler(token, matches);
};


/**
 * Matches the token against the start of words in the row.
 * @param {string} token Token to match.
 * @param {number} maxMatches Max number of matches to return.
 * @return {Array} Rows that match.
 */
el8.service.Search.prototype.getPrefixMatches =
    function(token, maxMatches) {
  var matches = [];

  if (token !== '') {
    var escapedToken = el8.service.Search.regExpEscape(token);
    var matcher = new RegExp('(^|\\W+)' + escapedToken, 'i');

    var that = this;
    el8.service.Search.some(this.rows_, function(row) {
      if (that.rowToStringFn_(row).match(matcher)) {
        matches.push(row);
      }
      return matches.length >= maxMatches;
    });
  }
  return matches;
};


/**
 * Matches the token against similar rows, by calculating "distance" between the
 * terms.
 * @param {string} token Token to match.
 * @param {number} maxMatches Max number of matches to return.
 * @return {Array} The best maxMatches rows.
 */
el8.service.Search.prototype.getSimilarRows =
    function(token, maxMatches) {

  var results = [];

  for (var index = 0; index < this.rows_.length; index++) {
      var row = this.rows_[index];
    var str = token.toLowerCase();
    var txt = this.rowToStringFn_(row).toLowerCase();
    var score = 0;

    if (txt.indexOf(str) !== -1) {
      score = parseInt((txt.indexOf(str) / 4).toString(), 10);

    } else {
      var arr = str.split('');

      var lastPos = -1;
      var penalty = 10;

      for (var i = 0; i < arr.length; i++) {

        var c = arr[i];
        var pos = txt.indexOf(c);

        if (pos > lastPos) {
          var diff = pos - lastPos - 1;

          if (diff > penalty - 5) {
            diff = penalty - 5;
          }

          score += diff;

          lastPos = pos;
        } else {
          score += penalty;
          penalty += 5;
        }
      }
    }

    if (score < str.length * 6) {
      results.push({
        str: row,
        score: score,
        index: index
      });
    }
  }

  results.sort(function(a, b) {
    var diff = a.score - b.score;
    if (diff !== 0) {
      return diff;
    }
    return a.index - b.index;
  });

  var matches = [];
  for (var i = 0; i < maxMatches && i < results.length; i++) {
    matches.push(results[i].str);
  }

  return matches;
};


/**
 * Escapes characters in the string that are not safe to use in a RegExp.
 * @param {*} s The string to escape. If not a string, it will be casted
 *     to one.
 * @return {string} A RegExp safe, escaped copy of {@code s}.
 */
el8.service.Search.regExpEscape = function(s) {
  // JS linter complained about unescaped dash here. We're ignoring for now, but
  // not adding a permanent exception to allow because we think it might be worth reviewing again
  return String(s).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, '\\$1').
      replace(/\x08/g, '\\x08');
};


/**
 * Goes through the values in the iterator. Calls f for each these and if any of
 * them returns true, this returns true (without checking the rest). If all
 * return false this will return false.
 *
 * @param {Object} iterable  The iterator object.
 * @param {Function} f  The function to call for every value. This function
 *     takes 3 arguments (the value, undefined, and the iterator) and should
 *     return a boolean.
 * @param {Object=} opt_obj The object to be used as the value of 'this' within
 *     {@code f}.
 * @return {boolean} true if any value passes the test.
 */
el8.service.Search.some = function(iterable, f, opt_obj) {
  for (var i = 0; i < iterable.length; i++) {
      if (f.call(opt_obj, iterable[i], undefined, iterable)) {
          return true;
      }
  }

  return false;
};


el8.service.Search.prototype.setRows = function(rows) {
  if (jQuery.isFunction(rows)) {
    this.rows_ = rows();
  } else {
    this.rows_ = rows;
  }
};

el8.service.Search.prototype.getRows = function() {
    return this.rows_;
};

